import { Packages } from '~shared/constants/pricing';

import { PackageColors, PackageTheme } from './types';
import { pricingPalette } from './colors';

export const packageColors: PackageColors = {
  advantageAnnual: pricingPalette.colors.sabaeus,
  advantageMonthly: pricingPalette.colors.sabaeus,
  basic: pricingPalette.colors.slate,
  enterprise: pricingPalette.colors.midnight,
  flex: pricingPalette.colors.arctic,
  premierAnnual: pricingPalette.colors.midnight,
  premierMonthly: pricingPalette.colors.midnight,
  starterAnnual: pricingPalette.colors.link,
  // Please note standard annual is still sold thru paymentweb,
  // for canonical reasons we should be careful changing the color scheme
  standardAnnual: pricingPalette.colors.link,
  starterMonthly: pricingPalette.colors.link, //  Standard Monthly in comparsion
  standardMonthly: pricingPalette.colors.arctic,
  teamAdvantage: pricingPalette.colors.link,
  teamPremier: pricingPalette.colors.concord,
  forms: pricingPalette.colors.concord,
};

export const packageTheme: PackageTheme = {
  [Packages.AdvantageAnnual]: {
    primary: packageColors.advantageAnnual,
  },
  [Packages.AdvantageMonthly]: {
    primary: packageColors.advantageMonthly,
  },
  [Packages.Basic]: {
    primary: packageColors.basic,
  },
  [Packages.Enterprise]: {
    primary: packageColors.enterprise,
  },
  [Packages.PremierAnnual]: {
    primary: packageColors.premierAnnual,
  },
  [Packages.StarterMonthly]: {
    primary: packageColors.starterMonthly,
  },
  [Packages.PremierMonthly]: {
    primary: packageColors.premierMonthly,
  },
  [Packages.StarterAnnual]: {
    primary: packageColors.starterAnnual,
  },
  [Packages.StandardMonthly]: {
    primary: packageColors.standardMonthly,
  },
  [Packages.StandardAnnual]: {
    // Noted, due to package canonical reasons we will deal wit it when the time arises
    primary: packageColors.standardAnnual,
  },
  [Packages.TeamAdvantage]: {
    primary: packageColors.teamAdvantage,
  },
  [Packages.TeamPremier]: {
    primary: packageColors.teamPremier,
  },
  [Packages.Flex]: {
    primary: packageColors.standardMonthly,
  },
  [Packages.FormsAnnual]: {
    primary: packageColors.forms,
  },
  [Packages.FormsMonthly]: {
    primary: packageColors.forms,
  },
};

export const pricingElevation: Record<string, number> = {
  zero: 0,
  minusOne: -1,
  plusOne: 1,
};
